import { PaginationResponse } from "models/pagination-response";
import { IRepasseSetorialPagedRequest } from "models/request/repasse-setorial-paged-request";
import { IRepasseSetorialPagedResponse } from "models/response/repasse-setorial-paged-response";
import { IAreaTransparenciaSetorialResponse } from "models/response/area-transparencia-setorial-response";
import { IOrigemRepasseSetorialResponse } from "models/response/origem-repasse-setorial-response";
import { IRepasseSetorialTotaisResponse } from "models/response/repasse-setorial-totais-response";

export type RepassesSetoriaisState = {
    repasses: PaginationResponse<IRepasseSetorialPagedResponse>;
    repassePagedRequest: IRepasseSetorialPagedRequest;
    areas: IAreaTransparenciaSetorialResponse[];
    origens: IOrigemRepasseSetorialResponse[];
    ultimaAtualizacao: string | null;
    totais: IRepasseSetorialTotaisResponse;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setRepasses = 'setRepasses',
    setRepassePagedRequest = 'setRepassePagedRequest',
    setAreas = 'setAreas',
    setOrigens = 'setOrigens',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setTotais = 'setTotais',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const RepassesSetoriaisReducer = (state: RepassesSetoriaisState, action: any): RepassesSetoriaisState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setRepassePagedRequest:
            return { ...state, repassePagedRequest: payload };
        case ACTION_TYPES.setRepasses:
            return { ...state, repasses: payload };
        case ACTION_TYPES.setAreas:
            return { ...state, areas: payload };
        case ACTION_TYPES.setOrigens:
            return { ...state, origens: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setTotais:
            return { ...state, totais: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
